module.exports = __webpack_public_path__ + "img/sp-lp-plan.a0903f67.jpg";